(function () {
  if (window.freejoyEditorialLoaded) return;
  window.freejoyEditorialLoaded = true;

  function initCarousels(root) {
    root.querySelectorAll('[data-fj-carousel]').forEach((carousel) => {
      if (carousel.dataset.fjReady === 'true') return;
      carousel.dataset.fjReady = 'true';
      const track = carousel.querySelector('[data-fj-track]');
      const previous = carousel.querySelector('[data-fj-prev]');
      const next = carousel.querySelector('[data-fj-next]');
      if (!track) return;

      const perPage = () =>
        window.matchMedia('(max-width: 749px)').matches
          ? Number(carousel.dataset.fjMobilePerPage || 1)
          : Number(carousel.dataset.fjPerPage || 1);

      const distance = () => {
        const item = track.firstElementChild;
        const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
        return ((item && item.getBoundingClientRect().width) || track.clientWidth) * perPage() + gap * perPage();
      };

      const updateControls = () => {
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth - 2);
        if (previous) previous.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= maxScroll;
      };

      previous?.addEventListener('click', () => track.scrollBy({ left: -distance(), behavior: 'smooth' }));
      next?.addEventListener('click', () => track.scrollBy({ left: distance(), behavior: 'smooth' }));
      track.addEventListener('scroll', () => requestAnimationFrame(updateControls), { passive: true });
      window.addEventListener('resize', updateControls, { passive: true });
      updateControls();
    });
  }

  function initSizeGuides(root) {
    root.querySelectorAll('[data-fj-size-guide-open]').forEach((button) => {
      if (button.dataset.fjReady === 'true') return;
      button.dataset.fjReady = 'true';
      const dialog = document.getElementById(button.getAttribute('aria-controls'));
      button.addEventListener('click', () => dialog?.showModal());
      dialog?.querySelector('[data-fj-size-guide-close]')?.addEventListener('click', () => dialog.close());
      dialog?.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
    });
  }

  function copyText(value) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(value);
    const input = document.createElement('textarea');
    input.value = value;
    input.setAttribute('readonly', '');
    input.style.position = 'fixed';
    input.style.opacity = '0';
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    input.remove();
    return Promise.resolve();
  }

  function initArticle(root) {
    root.querySelectorAll('[data-fj-article]').forEach((article) => {
      if (article.dataset.fjReady === 'true') return;
      article.dataset.fjReady = 'true';
      const content = article.querySelector('[data-fj-article-content]');
      const links = article.querySelector('[data-fj-toc-links]');

      if (content && links) {
        content.querySelectorAll('h2').forEach((heading, index) => {
          if (!heading.id) heading.id = `article-section-${index + 1}`;
          const link = document.createElement('a');
          link.href = `#${heading.id}`;
          link.textContent = `${String(index + 1).padStart(2, '0')} · ${heading.textContent.trim()}`;
          links.appendChild(link);
        });
      }

      article.querySelector('[data-fj-toc-toggle]')?.addEventListener('click', (event) => {
        const toggle = event.currentTarget;
        const toc = toggle.closest('.fj-article-toc');
        const isOpen = toc?.classList.toggle('is-open') || false;
        toggle.setAttribute('aria-expanded', String(isOpen));
      });

      article.querySelector('[data-fj-copy-link]')?.addEventListener('click', async () => {
        const status = article.querySelector('[data-fj-copy-status]');
        try {
          await copyText(location.href);
          if (status) status.textContent = 'Copied';
        } catch (error) {
          if (status) status.textContent = 'Copy failed';
        }
      });
    });
  }

  function init(root = document) {
    initCarousels(root);
    initSizeGuides(root);
    initArticle(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('click', (event) => {
    const proxy = event.target instanceof Element ? event.target.closest('[data-fj-size-guide-proxy]') : null;
    if (!proxy) return;
    const dialog = proxy.closest('.product-details')?.querySelector('.fj-size-guide-dialog');
    dialog?.showModal();
  });
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
